module.exports = __webpack_public_path__ + "static/media/iconAdminGray.869db5e0.svg";